import './Settings.css';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { QuestionCircle } from 'react-bootstrap-icons';
import EmailSettings from '../EmailSettings/EmailSettings';
import AccountSettings from '../AccountSettings/AccountSettings';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function Settings() {
    const [settingsModal, setSettingsModal] = useState(false);
    const handleSettingsModal = () => {
        setSettingsModal(!settingsModal);
    }

    return (
        <>
            <Modal
                size="md"
                show={settingsModal}
                onHide={() => handleSettingsModal()}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title className="w-100 text-center">
                        INSTRUCTIONS
            </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <p>Email Settings tab:</p>
                    <p>This table contains all of the data from the confirmation email that is sent after a referral partner makes a request.</p>
                    <p>Select the <Button variant="outline-primary" size="sm">Edit</Button> to Edit the confirmation email that is sent</p>
                    <p>The last row title "Notification Email" is the email address that recieves a notification when a request is made.</p>
                    <p>Account Settings tab:</p>
                    <p>Here you can either change the password of your account, add a new admin account, or print a CSV file of all the clients data.</p>
        </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        variant="primary"
                        onClick={handleSettingsModal}
                    >CLOSE</Button>
                </Modal.Footer>
            </Modal>

            <Container fluid>
                <Row className="ml-3 mb-3"><h3 id="settingsHeader">SETTINGS</h3>
                    <QuestionCircle
                        className="ml-2 py-1`"
                        type="button"
                        color="#d1a228" size={30}
                        onClick={handleSettingsModal}
                    /></Row>
                <Col>
                    <Tabs defaultActiveKey="emailSettings">
                        <Tab eventKey="emailSettings" title="Email Settings">
                            <EmailSettings />
                        </Tab>
                        <Tab eventKey="accountSettings" title="Account Settings">
                            <AccountSettings />
                        </Tab>

                    </Tabs>
                </Col>
            </Container>
        </>
    );
}

export default Settings;